<!--
File: product-toolbar-product-details.component.html
Project: catalog-cloud
File Created: Monday, 7th March 2022 12:47:46
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Friday, 23rd May 2025 9:39:42 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<strong class="m-0">{{ item.name }}</strong>
<div class="flex flex-column bg-blue-50 text-gray-900">
  <div class="align-self-start w-full">
    <img
      class="m-0 p-1 image-product-details"
      [src]="item.img == null ? './assets/img/nube_cc_200x140.png' : item.img"
    />
  </div>
  <table class="table-product-description text-sm border-round shadow-2">
    <tbody>
      <tr>
        <td>{{ "DESCRIPTION" | translate }}</td>
        <td>{{ item.description }}</td>
      </tr>
      <tr>
        <td>{{ "TAGS" | translate }}</td>
        <td>{{ item.tags.toString() }}</td>
      </tr>
      <tr>
        <td>{{ "PRODUCT.FAMILY" | translate }}</td>
        <td>{{ item.family }}</td>
      </tr>
      <span>--- EXTRA --</span>
      <tr *ngFor="let extra in item.extraFields; let i=index">
        <td>{{ extra.label }}</td>
        <td>{{ extra.value }}</td>
      </tr>
      <span>--- EXTRA --</span>
      <tr>
        <td>{{ "CREATED_AT" | translate }}</td>
        <td>{{ item.createdAt | date : "dd/MM/yyyy - HH:mm" }}</td>
      </tr>
    </tbody>
  </table>
</div>

<span *ngIf="!item"> No hay item</span>
